/* eslint-disable @next/next/no-img-element */
import { memo, useRef, useState } from 'react';
import Div from '../Div';
import useListenWindowEvent from '@/hooks/useListenWindowEvent';
import useOnMount from '@/hooks/useOnMount';
import Container from '../Container';
import Heading from '../Heading';
import useScreen from '@/hooks/useScreen';
import dlv from 'dlv';

export const PurificationStagesScroll = ({
  videoDuration,
  playback,
  title,
  mobileVideo,
  desktopVideo,
}: any) => {
  const videoElement = useRef<HTMLVideoElement>(null);
  const heightElement = useRef<HTMLDivElement>(null);
  const videoWrapperElement = useRef<HTMLDivElement>(null);
  const windowRequestAnimationFrame = useRef<number | null>(null);
  const scrollTimeout = useRef<any>(null);
  const { isDesktop } = useScreen();
  const top = useRef<any>(0);
  const [ready, setReady] = useState(false);
  const triggerAnimation = useRef(false);
  const videoSrc = isDesktop
    ? dlv(desktopVideo, 'data.attributes.url')
    : dlv(mobileVideo, 'data.attributes.url');

  useOnMount(() => {
    if (heightElement.current && videoElement.current && videoSrc) {
      heightElement.current.style.height = videoDuration * playback + 'px';
      videoElement.current.style.top = top.current;
      videoElement.current.load();
      setReady(true);
    }
  });

  // Use requestAnimationFrame for smooth playback
  const scrollPlay = () => {
    if (triggerAnimation.current && videoElement.current) {
      console.log(':::: requestAnimationFrame running ::::');
      videoElement.current.currentTime = window.scrollY / playback;
      windowRequestAnimationFrame.current = window.requestAnimationFrame(scrollPlay);
    }
  };

  const clear = () => {
    triggerAnimation.current = false;
    if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
    if (windowRequestAnimationFrame.current)
      window.cancelAnimationFrame(windowRequestAnimationFrame.current);
  };

  const onScroll = () => {
    if (videoElement.current && heightElement.current && videoWrapperElement.current && ready) {
      const { y } = heightElement.current?.getBoundingClientRect();
      const absoluteY = Math.abs(y);
      const height = parseInt(heightElement.current.style.height);

      if (
        y <= top.current &&
        height - (videoWrapperElement.current.offsetHeight + top.current) >= absoluteY
      ) {
        if (!triggerAnimation.current) {
          triggerAnimation.current = true;
          scrollTimeout.current = setTimeout(() => {
            clear();
          }, 200);
          // scrollPlay()
          windowRequestAnimationFrame.current = window.requestAnimationFrame(scrollPlay);
        }
      } else {
        if (triggerAnimation.current) {
          clear();
          videoElement.current.currentTime = 0;
        }
      }
    }
  };

  useListenWindowEvent('scroll', onScroll, 1);

  if (!videoSrc) return null;

  return (
    <Div className="bg-cm-primary z-40 relative">
      <Container>
        <Div ref={heightElement} className="bg-cm-bold relative">
          <Div
            ref={videoWrapperElement}
            className="sticky left-0 w-full"
            style={{
              top: top.current,
              height: `calc(100vh - ${top.current}px)`,
            }}
          >
            <Div className="flex flex-col items-center h-full">
              {/* <Heading
              className="text-h-1 md:text-hd-1 text-center text-cs-primary pb-s6 py-s6 md:py-16"
              level={3}
            >
              {title}
            </Heading> */}
              <video
                id="v0"
                ref={videoElement}
                tabIndex={0}
                className="m-auto w-full"
                style={{
                  height: isDesktop ? 600 : 428,
                }}
                preload="preload"
              >
                <source src={videoSrc} type="video/mp4" />
              </video>
            </Div>
          </Div>
        </Div>
      </Container>
    </Div>
  );
};

export default memo(PurificationStagesScroll);
